export default __webpack_public_path__ + "static/media/Imagesources_result_02.8051a0c7.png";